import HttpService from '../../services/HttpService';
import ErrorSwitchCase from '../../services/ErrorHandlerService';
import { ADMIN_PATH } from '../../url';

const _axios = HttpService.getAxiosClient();

/**
 * Admin sometimes historically returned HTTP 200 with an error body
 * (status "400"). Prefer body status when it indicates failure; otherwise
 * use the HTTP status so success bodies like "200 OK" still work.
 */
const toServiceResponse = (axiosResponseOrBody, fromCatch = false) => {
  if (!fromCatch && axiosResponseOrBody?.data !== undefined) {
    const httpStatus = axiosResponseOrBody.status;
    const body = axiosResponseOrBody.data;
    const bodyCode = parseStatusCode(body?.status);
    if (bodyCode != null && bodyCode >= 400) {
      return ErrorSwitchCase({ ...body, status: bodyCode });
    }
    return ErrorSwitchCase({
      ...body,
      status: httpStatus,
      data: body,
    });
  }

  const body = axiosResponseOrBody;
  const bodyCode = parseStatusCode(body?.status);
  return ErrorSwitchCase({
    ...body,
    status: bodyCode != null ? bodyCode : body?.status,
  });
};

const parseStatusCode = (status) => {
  if (status == null) return null;
  const match = String(status).trim().match(/^(\d+)/);
  if (!match) return null;
  const code = parseInt(match[1], 10);
  return Number.isNaN(code) ? null : code;
};

export const getQuarterlyCasualLeaveAllocation = async (
  employeeId,
  year,
  adjustmentPage = 0,
  adjustmentSize = 10,
) => {
  try {
    const response = await _axios.get(
      `${ADMIN_PATH}/quarterly-casual-leave/${employeeId}/${year}`,
      {
        params: { adjustmentPage, adjustmentSize },
      },
    );
    return toServiceResponse(response);
  } catch (error) {
    return toServiceResponse(error.response?.data, true);
  }
};

export const getQuarterlyCasualLeaveAdjustments = async (
  employeeId,
  year,
  page = 0,
  size = 10,
) => {
  try {
    const response = await _axios.get(
      `${ADMIN_PATH}/quarterly-casual-leave/${employeeId}/${year}/adjustments`,
      {
        params: { page, size },
      },
    );
    return toServiceResponse(response);
  } catch (error) {
    return toServiceResponse(error.response?.data, true);
  }
};

export const updateQuarterlyCasualLeaveAllocation = async (
  employeeId,
  year,
  payload,
) => {
  try {
    const response = await _axios.put(
      `${ADMIN_PATH}/quarterly-casual-leave/${employeeId}/${year}`,
      payload,
    );
    return toServiceResponse(response);
  } catch (error) {
    return toServiceResponse(error.response?.data, true);
  }
};
